import { render, staticRenderFns } from "./shipmentFlowView.vue?vue&type=template&id=48727d5a&scoped=true"
import script from "./shipmentFlowView.vue?vue&type=script&lang=js"
export * from "./shipmentFlowView.vue?vue&type=script&lang=js"
import style0 from "./shipmentFlowView.vue?vue&type=style&index=0&id=48727d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48727d5a",
  null
  
)

export default component.exports